import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyWithoutSymbol'
})
export class CurrencyWithoutSymbolPipe implements PipeTransform {
  transform(value: number): string {
    if (value == null || isNaN(value)) return '';

    // Convert the number to a string and replace any non-numeric characters
    return value.toLocaleString('en-US', { maximumFractionDigits: 0 });
  }
}



// WEBPACK FOOTER //
// ./src/app/currency-without-symbol.pipe.ts